import { RecordingAgentReg } from "@api";

export class NewMeetingInfo {
    id: string;
    subject: string;
    startDateUtc: Date;
    endDateUtc: Date;
    location: string 
    recordingFile: File;
    isPlannedRecording: boolean;
    plannedAgentRegId: string;
    plannedAgentSeetings: RecordingAgentReg;
}